{{#with currentItem}}
    <div style="margin-bottom: 30px;">
        <div class="blocks blocks_spread">
        {{#if isTemplated}}
        {{else if isPODStored}}
        {{else}}
            <span class="lbl lbl_sm lbl_bold">[ {{productName}} ]</span>
        {{#if displayTotalPrice}}
            <div class="lbl lbl_sm"><span class="lbl_bold">Price:</span> {{displayTotalPrice}}</div>
        {{/if}}
        {{#if quantity}}
            <div class="lbl lbl_sm"><span class="lbl_bold">{{#if configDetails.versions}}Total {{/if}}Quantity:</span> {{quantity}}</div>
        {{/if}}
        {{/if}}
        </div>
    </div>
    <div>
        {{#if isTemplated}}
        <h3 class="lbl lbl_lg">{{productName}}</h3>
        {{else}}
        <form class="spdcForm">
            <div class="spdcForm-row"> {{!-- spdcForm-row_2up --}}
                <div class="spdcForm-row-item">
                    <label class="spdcForm-lbl" for="name">New Job Name</label>
                    <input class="spdcForm-inputText js-element--jobName" id="name" type="text" value="{{../name}}">
                </div>
            </div>
            {{#if companionItemNames.length}}
            <div class="spdcForm-row">
                <div class="spdcForm-row-item">
                    {{!-- The input must PRECEDE the label as a sibling, not be nested inside it:
                          spdcForm.css absolutely positions .spdcForm input[type=checkbox], and the
                          padding-left that clears it is only on `input[type=checkbox] + label`.
                          Nested, that selector never matched and the checkbox sat on top of the
                          text. `spdcForm-lbl_checkbox` was also never defined in any stylesheet. --}}
                    <input class="js-element--includeCompanions" id="includeCompanions-{{id}}" type="checkbox" checked>
                    <label for="includeCompanions-{{id}}">
                        Also duplicate the matching {{#each companionItemNames}}{{this}}{{#unless @last}}, {{/unless}}{{/each}}
                    </label>
                </div>
            </div>
            {{/if}}
            <div class="spdcForm-row">
                <ul class="hList hList_spread hList_alignRight js-actionsContainer {{#if ../loading}} requestIsProcessing{{/if}}">
                    <li><a href="" class="link js-action--cancel">cancel</a></li>
                    <li><a href="" class="btn btn_reversed js-action--confirm">Duplicate Item</a></li>
                </ul>
            </div>
        </form>
        {{/if}}
    </div>
    <div style="padding: 20px 40px; margin: 20px -40px -40px -40px; background-color: var(--c-OFFWHITE);">
        <table class="keyValTable keyValTable_40-60 keyValTable_ruleAbove">
            <tbody>
                {{#each configDetails.choices}}
                <tr>
                    <td class="lbl lbl_sm lbl_bold">{{key}}</td>
                    <td class="lbl lbl_serif" style="text-transform: lowercase;">{{value}}</td>
                </tr>
                {{/each}}
                {{#if configDetails.versions}}
                <tr>
                    <td class="lbl lbl_sm lbl_bold">Total Quantity</td>
                    <td class="lbl lbl_serif" style="text-transform: lowercase;">{{quantity}}</td>
                </tr>
                <tr>
                    <td class="lbl lbl_sm lbl_bold">Quantity by Version</td>
                    <td class="lbl lbl_serif" style="text-transform: lowercase;">
                        {{#each configDetails.versions}}
                        <div>{{key}}: {{value}}</div>
                        {{/each}}
                    </td>
                </tr>
                {{else}}
                {{#if quantity}}
                <tr>
                    <td class="lbl lbl_sm lbl_bold">Total Quantity</td>
                    <td class="lbl lbl_serif" style="text-transform: lowercase;">{{quantity}}</td>
                </tr>
                {{/if}}
                {{/if}}
                {{#each configDetails.additionalChoices}}
                <tr>
                    <td class="lbl lbl_sm lbl_bold">{{key}}</td>
                    <td class="lbl lbl_serif" style="text-transform: lowercase;">{{value}}</td>
                </tr>
                {{/each}}
            </tbody>
        </table>
    </div>
    {{/with}}
